import api from '@/api/index.js'

const pt_stop = {
  state: {
    loading: false,
    updating: false,
    error: null
  },

  mutations: {
    SET_PT_STOP_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_PT_STOP_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_PT_STOP_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    },
  },

  actions: {
    CreatePtStop({commit}, payload) {
      commit('SET_PT_STOP_UPDATING', true);
      commit('SET_PT_STOP_ERROR', null)
      commit('SET_ERROR', null)
      return api.post(`pt-stops`, payload)
        .then((response) => {
          commit('SET_PT_STOP_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_PT_STOP_ERROR', error);
          commit('SET_PT_STOP_UPDATING', false);
        })
    },
    DeletePtStop({commit}, payload) {
      commit('SET_PT_STOP_UPDATING', true);
      commit('SET_PT_STOP_ERROR', null)
      commit('SET_ERROR', null)
      return api.delete(`pt-stops/${payload.id}`)
        .then((response) => {
          commit('SET_PT_STOP_DELETED', payload);
          commit('SET_PT_STOP_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_PT_STOP_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_PT_STOP_UPDATING', false);
        })
    },
    UpdatePtStop({commit}, payload) {
      commit('SET_PT_STOP_UPDATING', true);
      commit('SET_PT_STOP_ERROR', null)
      commit('SET_ERROR', null)
      return api.put(`pt-stops/${payload.id}`, payload)
        .then((response) => {
          commit('SET_PT_STOP_UPDATED', response.body);
          commit('SET_PT_STOP_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_PT_STOP_ERROR', error);
          commit('SET_PT_STOP_UPDATING', false);
        })
    },
  }
}

export default pt_stop
